import { hasActionBarCrossSellAttributionForSkus } from '~/utils/actionBarCrossSellAnalytics/getActionBarCrossSellAttributionForSku';
import { ACTION_BAR_CROSS_SELL_ECOM_SOURCE } from '~/utils/actionBarCrossSellAnalytics/types';
import { hasProductFinderAttributionForSkus } from '~/utils/productFinderAnalytics/getProductFinderAttributionForSku';
import type { ModifyCartItemByDecoratedProduct } from '~/stores/cartStore/model';

export function resolveEcommerceSourceForCartItems(
  cartItems: ReadonlyArray<ModifyCartItemByDecoratedProduct>,
  explicitSource?: string
): string {
  if (explicitSource) {
    return explicitSource;
  }

  const skus = cartItems
    .map((item) => item.decoratedProduct.sku)
    .filter((sku): sku is string => Boolean(sku));
  if (hasProductFinderAttributionForSkus(skus)) {
    return 'productFinder';
  }
  if (hasActionBarCrossSellAttributionForSkus(skus)) {
    return ACTION_BAR_CROSS_SELL_ECOM_SOURCE;
  }

  return 'website';
}
